import { Component } from '@angular/core';
import { Screen } from 'app/screen';
declare var window: any;
import * as moment from 'moment-timezone';

@Component({
    selector: 'screen-trendreport-desktop',
    templateUrl: 'trendreport.html'
})
export class trendreport_Desktop extends Screen {
    data: any;

    ngOnInit(): void {
        super.ngOnInit();
        // Logic to run when the screen loads goes here.
    }

    ngOnDestroy(): void {
        super.ngOnDestroy();
        // Logic to run when the screen unloads goes here.
    }

    onDataLoad(data: any): void {
        this.data.screenId = "trendreport";
        this.data.startDate = this.global.startDate || "2024-01-01";
        this.data.endDate = this.global.endDate || "2024-01-01";
        this.data.startTime = this.global.startTime || "00:00";
        this.data.endTime = this.global.endTime || "23:59";

        this.data.productCodes.selected = this.global.productCode || '';
        this.data.tagSelected.selected = this.global.tagSelected || '';

        this.loadProductCodes();
        this.loadTags();
        this.updateQuery();
        this.data.tagMetadata = {};
    }

    async ionViewCanLeave() {
        await super.ionViewCanLeave();
        this.global.startDate = this.data.startDate;
        this.global.endDate = this.data.endDate;
        this.global.startTime = this.data.startTime;
        this.global.endTime = this.data.endTime;
        this.global.productCode = this.data.productCodes.selected;
        this.global.tagSelected = this.data.tagSelected.selected;
    }

    loadProductCodes() {
        this.fetchWithOptions("https://demo-api.app.smartux.com/api/v2/sensordata/tagquery", {
            method: "POST",
            body: JSON.stringify({
                "QueryString": "SELECT productId " +
                "FROM \"${database}\".\"${table}\" " +
                "WHERE measure_name='FD_RUNNING' AND productId <> '' AND " +
                `time BETWEEN '${this.data.startDate} ${this.data.startTime}:00.000000000' AND '${this.data.endDate} ${this.data.endTime}:00.000000000' ` +
                "GROUP BY productId ORDER BY productId ASC"
            })
        }, (response) => {
            this.data.productCodes.options = response.map(row => ({ label: row.productId.toUpperCase(), value: row.productId }));
            //this.data.productCodes.options.sort((a, b) => a.label.localeCompare(b.label));
            this.data.productCodes.options.unshift({
                label: 'All',
                value: ''
            });
        }, (error) => {
            console.error("Error", error);
            this.alert(error.message);
        });
    }

    loadTags() {
        this.fetchWithOptions("https://demo-api.app.smartux.com/api/v2/sensordata/taglist?plantid=MTH&columns=PlantID, FETagID, TagDesc", {
            method: "GET"
        }, (response) => {
            this.data.tagSelected.options = response.taglist.map(row => {
                if (row.Metadata) {
                    this.data.tagMetadata[row.FETagID] = row.Metadata;
                }
                return {
                    label: row.TagDesc,
                    value: row.FETagID
                };
            });
            //this.data.productCodes.options.sort((a, b) => a.label.localeCompare(b.label));
            this.data.tagSelected.options.unshift({
                label: 'Select...',
                value: ''
            });
        }, (error) => {
            console.error("Error", error);
            this.alert(error.message);
        });
    }

    updateQuery() {
        // Logic to run when the screen's data is updated goes here.
        this.fetchWithOptions("https://demo-api.app.smartux.com/api/v2/sensordata/tagquery", {
            method: "POST",
            body: JSON.stringify({
                "QueryString": "SELECT time, measure_name, productId, batchId, mcrunning, anomalycount, numvalue " +
                "FROM \"${database}\".\"${table}\" " +
                "WHERE " +
                (this.data.tagSelected.selected ? `measure_name='${this.data.tagSelected.selected}' AND ` : '') +
                (this.data.productCodes.selected ? `productId='${this.data.productCodes.selected}' AND ` : '') +
                `time BETWEEN '${this.data.startDate} ${this.data.startTime}:00.000000000' AND '${this.data.endDate} ${this.data.endTime}:00.000000000' ORDER BY time ASC`
            })
        }, (response) => {
            this.processResponse(response);
        }, (error) => {
            console.error("Error", error);
            this.alert(error.message);
        });
    }

    changeDateTimeInput() {
        this.data.invalidDateQuery = !this.data.startDate || !this.data.endDate || !this.data.startTime || !this.data.endTime;

        if (!this.data.invalidDateQuery) {
            if (new Date(this.data.endDate) < new Date(this.data.startDate)) {
                this.data.endDate = this.data.startDate;
            }
            if (this.data.endDate == this.data.startDate) {
                if (new Date(this.data.endTime) < new Date(this.data.startTime)) {
                    this.data.endTime = this.data.startTime;
                }
            }
            this.updateQuery();
        }
    }

    changeProductCode() {
        this.updateQuery();
    }

    changeTag() {
        this.updateQuery();
    }

    processResponse(arrTimeSeries) {

        this.data.tableData = [{
            name: "Samples"
        }, {
            name: "Average"
        }, {
            name: "Std Dev"
        }, {
            name: "-3 Std Dev"
        }, {
            name: "+3 Std Dev"
        }, {
            name: "LSL"
        }, {
            name: "USL"
        }, {
            name: "PlantTarget Lower"
        }, {
            name: "PlantTarget Upper"
        }, {
            name: "CPK"
        }];

        this.data.chartData = [{
            name: "Average",
            series: []
        }, {
            name: "   -3 Std Dev",
            series: []
        }, {
            name: "   +3 Std Dev",
            series: []
        }, {
            name: "CPK",
            series: []
        }];

        this.data.columns = [{
            "title": "Record Type",
            "field": "name",
            "minWidth": 100,
            "maxWidth": 200,
            "resizable": true,
            "sorter": "string",
            "headerSort": false,
            "headerHozAlign": "center",
            "hozAlign": "left",
            "frozen": true
        }];

        if (!arrTimeSeries || arrTimeSeries.length == 0) {
            return;
        }
        let firstTime = moment(arrTimeSeries[0].time.substring(0, arrTimeSeries[0].time.indexOf('.')));
        let lastTime = moment(arrTimeSeries[arrTimeSeries.length - 1].time.substring(0, arrTimeSeries[arrTimeSeries.length - 1].time.indexOf('.')));
        //
        let labelNeedsDay = !lastTime.isSame(firstTime, 'day');
        let firstInterval = firstTime.clone().startOf("hour");
        let lastInterval = lastTime.clone().add(1, 'hour').startOf("hour");
        let numIntervals = lastInterval.diff(firstInterval, "hours");

        let groupedValues = [];

        let startInterval = firstInterval.clone();
        for (let i = 0; i < numIntervals; i++) {
            let startLabel = startInterval.format(labelNeedsDay ? "M/D hA" : "hA");
            let endInterval = startInterval.clone().add(1, 'hour');
            groupedValues[i] = {
                label: startLabel,
                vals: []
            };
            startInterval = endInterval;
        }

        let lastProductId = null;
        for (let i = 0; i < arrTimeSeries.length; i++) {
            arrTimeSeries[i].time = arrTimeSeries[i].time.substring(0, arrTimeSeries[i].time.indexOf('.'));
            let eventTime = moment(arrTimeSeries[i].time);
            let eventIndex = eventTime.diff(firstInterval, "hours");
            groupedValues[eventIndex].vals.push(parseFloat(arrTimeSeries[i].numvalue));
        }

        let LSL = 0;
        let USL = 0;
        if (this.data.tagMetadata[this.data.tagSelected.selected]) {
            LSL = this.data.tagMetadata[this.data.tagSelected.selected].LSL;
            USL = this.data.tagMetadata[this.data.tagSelected.selected].USL;
        }
        let PlantTargetLower = LSL;
        let PlantTargetUpper = USL;

        for (let i = 0; i < numIntervals; i++) {
            let label = groupedValues[i].label;
            let fieldId = `timeInterval${i}`;

            let arr = groupedValues[i].vals;
            let n = arr.length;
            let mean = arr.reduce((sum, x) => sum + x, 0) / n;
            let arrSquareDiffs = arr.map(x => Math.pow(x - mean, 2));
            let variance = arrSquareDiffs.reduce((sum, x) => sum + x, 0) / n;
            let stdDev = Math.sqrt(variance);
            let stdDevPlus3 = mean + (3 * stdDev);
            let stdDevMinus3 = mean - (3 * stdDev);
            let CPK = stdDev ? Math.min((USL - mean) / (3 * stdDev), (mean - LSL) / (3 * stdDev)) : 0;

            this.data.columns.push({
                "title": label,
                "field": fieldId,
                "minWidth": 100,
                "maxWidth": 200,
                "resizable": true,
                "sorter": "string",
                "headerSort": false,
                "headerHozAlign": "center",
                "hozAlign": "left"
            });
            this.data.tableData[0][fieldId] = n;
            this.data.tableData[1][fieldId] = mean.toFixed(2);
            this.data.tableData[2][fieldId] = stdDev.toFixed(2);
            this.data.tableData[3][fieldId] = stdDevMinus3.toFixed(2);
            this.data.tableData[4][fieldId] = stdDevPlus3.toFixed(2);
            this.data.tableData[5][fieldId] = LSL;
            this.data.tableData[6][fieldId] = USL;
            this.data.tableData[7][fieldId] = PlantTargetLower;
            this.data.tableData[8][fieldId] = PlantTargetUpper;
            this.data.tableData[9][fieldId] = CPK.toFixed(2);

            this.data.chartData[0].series.push({ name: label, value: mean.toFixed(2) });
            this.data.chartData[1].series.push({ name: label, value: stdDevMinus3.toFixed(2) });
            this.data.chartData[2].series.push({ name: label, value: stdDevPlus3.toFixed(2) });
            this.data.chartData[3].series.push({ name: label, value: CPK.toFixed(2) });

            this.data.referenceLines = [{
                name: 'LSL',
                value: LSL
            }, {
                name: 'USL',
                value: USL
            }];

        }
    }

    onBackButton(): boolean {
        //(Android) returns :
        // true - handle the event in App Hooks
        // false - stop the event propogation
        return true;
    }
}



// WEBPACK FOOTER //
// ./src/pages/trendreport/Desktop/trendreport.ts